// Module-level render stats — written by `RenderStatsCollector` (inside <Canvas>)
// each frame, read by the `DebugHud` via a getter at a throttled cadence.
//
// Single WebGLRenderer per session, so a module-level singleton is fine.

export interface RenderStatsSnapshot {
  /** Draw calls this frame (three.js resets `gl.info.render.calls` per frame). */
  readonly drawCalls: number;
  /** Triangle count this frame. */
  readonly triangles: number;
  /** Distinct geometries in the GPU memory tracker. */
  readonly geometries: number;
  /** Distinct textures in the GPU memory tracker. */
  readonly textures: number;
  /** Programs (shaders) compiled. */
  readonly programs: number;
  /** Frames per second, smoothed over the last ~1s. */
  readonly fps: number;
}

export const renderStats: RenderStatsSnapshot & {
  drawCalls: number;
  triangles: number;
  geometries: number;
  textures: number;
  programs: number;
  fps: number;
} = {
  drawCalls: 0,
  triangles: 0,
  geometries: 0,
  textures: 0,
  programs: 0,
  fps: 0,
};

export function readRenderStats(): RenderStatsSnapshot {
  return {
    drawCalls: renderStats.drawCalls,
    triangles: renderStats.triangles,
    geometries: renderStats.geometries,
    textures: renderStats.textures,
    programs: renderStats.programs,
    fps: renderStats.fps,
  };
}
